import React from 'react';
import { useLastRefresh } from '@/hooks/useLastRefresh';
import { useTenant } from '@/contexts/TenantContext';

interface LastRefreshIndicatorProps {
  className?: string;
  type?: 'recall-data' | 'user-preferences' | 'technicians';
}

export const LastRefreshIndicator: React.FC<LastRefreshIndicatorProps> = ({
  className = '',
  type = 'recall-data'
}) => {
  const { lastRefresh, loading, error } = useLastRefresh(type);
  const { currentTenant } = useTenant();
  const tenantTimezone = currentTenant?.time_zone || 'America/New_York';

  // Format date using tenant's timezone
  const formatDate = (date: Date): string => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: tenantTimezone
    }).format(date);
  };

  if (loading) {
    return (
      <div className={`text-sm text-muted-foreground italic ${className}`}>
        Loading last refresh time...
      </div>
    );
  }

  if (error) {
    return (
      <div className={`text-sm text-destructive italic ${className}`}>
        Error loading refresh time
      </div>
    );
  }

  if (!lastRefresh) {
    return (
      <div className={`text-sm text-muted-foreground italic ${className}`}>
        No refresh time available
      </div>
    );
  }

  return (
    <div className={`text-sm text-muted-foreground italic ${className}`}>
      Last refreshed: {formatDate(lastRefresh)}
    </div>
  );
};
